"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/features/array/includes");
var analytics_1 = require("@findify/analytics");
var events_1 = require("./bindings/events");
var filters_1 = require("./bindings/filters");
var dom_1 = require("./bindings/dom");
var element_dataset_1 = require("element-dataset");
var types_1 = require("@findify/analytics/lib/types");
element_dataset_1.default();
var analyticsInstance;
var initialize = function (config, onReady) {
    if (config === void 0) { config = { events: {} }; }
    var eventsConfig = config && config.events || {};
    analyticsInstance.state = __assign({}, analyticsInstance.state, { filters: filters_1.getFiltersOnPage(document) });
    analyticsInstance.invalidate(events_1.getDeprecatedEvents(document));
    analyticsInstance.invalidate(events_1.getEventsOnPage(document));
    dom_1.startDOMListeners(analyticsInstance.sendEvent, document);
    if (eventsConfig[types_1.EventName.viewPage] !== false &&
        !analyticsInstance.state.events[types_1.EventName.viewPage]) {
        analyticsInstance.sendEvent(types_1.EventName.viewPage, {});
    }
    if (!!onReady)
        onReady();
};
var analyticsDOM = function (props, context, onReady) {
    if (context === void 0) { context = document; }
    if (onReady === void 0) { onReady = undefined; }
    if (typeof props === 'function')
        return analytics_1.default(props);
    if (analyticsInstance)
        return analyticsInstance;
    analyticsInstance = analytics_1.default(props);
    if (['complete', 'loaded', 'interactive'].includes(document.readyState) && document.body) {
        initialize(props, onReady);
    }
    else {
        document.addEventListener('DOMContentLoaded', function () { return initialize(props, onReady); }, false);
    }
    return analyticsInstance;
};
analyticsDOM.prototype.__analytics = analytics_1.default;
exports.default = analyticsDOM;
//# sourceMappingURL=index.js.map